module.exports = __webpack_public_path__ + "static/media/fruits_24.5ca22422.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_24.csv
// module id = 689
// module chunks = 0